import {cx} from "@emotion/css";

import {classCombinerFromPrefix} from "@/app/pages/upik/resources/RenderIdentifier";
import * as  ContainerStyles from "@/app/pages/upik/styles/ContainerStyles.module.scss";
import React from "react";

const styles = ContainerStyles;

type HeaderProps = {
    currentPagePath?: string;
    language: string | undefined;
    otherLanguagePageUrl: string;
};

const classCombiner = classCombinerFromPrefix("a43bb12b864a3f8f");

export const Header = ({
    currentPagePath,
    language,
    otherLanguagePageUrl,
}: HeaderProps): JSX.Element => {

    const getPageUrl = (linkName: string) => {
        if (linkName === "german") {
            if (language === "de") {
                return currentPagePath?.replace(".html","");
            }
            return otherLanguagePageUrl;
        }

        if (linkName === "english") {
            if (language === "en") {
                return currentPagePath?.replace(".html","");
            }
            return otherLanguagePageUrl;
        }

        return "#";
    };

    const germanTabClass = language === "de" ? "upikHeaderLinkActive" : "upikHeaderLink";
    const englishTabClass = language === "en" ? "upikHeaderLinkActive" : "upikHeaderLink";

    return (
        <div className={cx(classCombiner(styles, "upikHeaderDesktopOuterWrapper"))}>
            <div className={cx(classCombiner(styles, "upikHeaderDesktop"))}>
                <div className={cx(classCombiner(styles, "upikHeaderDesktopInnerWrapper"))}>
                    <div className={cx(classCombiner(styles, "upikHeaderBeginningPadding"))} />

                    <div className={cx(classCombiner(styles, "upikHeaderLogoWrapper"))}>
                        <a
                            aria-label="Homepage link"
                            href="#"
                        >
                            <div
                                aria-label="D&B logo"
                                className={cx(
                                    classCombiner(styles, "upikHeaderLogo"),
                                    classCombiner(styles, "upikHeaderLogoBG")
                                )}
                                role="img"
                            />
                        </a>
                    </div>

                    <div className={cx(classCombiner(styles, "upikHeaderMiddlePadding"))} />

                    <div
                        className={cx(classCombiner(styles, "upikHeaderSearchAndLinksWrapper"))}
                    >
                        <div className={cx(classCombiner(styles, "upikHeaderLinksWrapper"))}>
                            <a
                                className={cx(
                                    classCombiner(styles, germanTabClass)
                                )}
                                href={`${getPageUrl("german")}.html`}
                            >
                                {language === "de" ? "Deutsch" : "German"}
                            </a>

                            {" "}

                            {" "}

                            |
                            {" "}

                            <a
                                className={cx(
                                    classCombiner(styles, englishTabClass)
                                )}
                                href={`${getPageUrl("english")}.html`}
                            >
                                English
                            </a>
                        </div>
                    </div>

                    <div className={cx(classCombiner(styles, "upikHeaderEndPadding"))} />
                </div>
            </div>
        </div>
    );
};
